import { StoreMappingListPage } from "@/features/store-mapping/pages/StoreMappingListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/store-mapping/")({
	component: StoreMappingListPage,
});
